export var config = {
    nextRacesCount: 3,
    nextLinesCount: 3,
    nextRacesRowHeight: 53 //px
};
//# sourceMappingURL=config.js.map